import { BehaviorSubject } from 'rxjs';

export class HttpErrors {
  static status = new BehaviorSubject(-1);
}
